var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlockfactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194.048,
    height: 25.942,
    viewBox: "0 0 194.048 25.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(-2363.113 -1282.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(2400.291 1288.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M5.688-41.969V-56.184h2.75v14.215ZM7.71-47.792v-2.447h7.158v2.447Zm0-5.965v-2.426h7.5v2.426Zm7.037,11.788,5.722-14.215h2.244l5.7,14.215H25.484L21.076-53.636h1.011L17.618-41.969Zm3.033-2.649v-2.305h7.643v2.305Zm17.693,2.851a7.442,7.442,0,0,1-2.891-.556,7.164,7.164,0,0,1-2.335-1.557,6.9,6.9,0,0,1-1.537-2.335,7.634,7.634,0,0,1-.536-2.871,7.634,7.634,0,0,1,.536-2.871,6.8,6.8,0,0,1,1.537-2.325,7.415,7.415,0,0,1,2.325-1.557,7.305,7.305,0,0,1,2.9-.566,7.525,7.525,0,0,1,2.993.556,7.422,7.422,0,0,1,2.285,1.527l-1.86,1.86a4.074,4.074,0,0,0-1.436-1.011,5,5,0,0,0-1.982-.364,4.754,4.754,0,0,0-1.81.334,4.063,4.063,0,0,0-1.426.971,4.343,4.343,0,0,0-.93,1.517,5.555,5.555,0,0,0-.324,1.931,5.532,5.532,0,0,0,.324,1.941,4.362,4.362,0,0,0,.93,1.506,4.182,4.182,0,0,0,1.426.981,4.631,4.631,0,0,0,1.81.344,5.245,5.245,0,0,0,2.052-.364A3.939,3.939,0,0,0,38.97-45.71l1.86,1.86a7.051,7.051,0,0,1-2.305,1.537A7.913,7.913,0,0,1,35.472-41.767Zm10.151-.2V-55.88h2.77v13.911ZM41.093-53.737v-2.447H52.922v2.447ZM73.81-47.914v-2.143h3.3a2.219,2.219,0,0,0,1.567-.516A1.848,1.848,0,0,0,79.229-52a1.88,1.88,0,0,0-.556-1.385,2.119,2.119,0,0,0-1.567-.556h-3.3v-2.244h3.539a5.21,5.21,0,0,1,2.416.536,4.016,4.016,0,0,1,1.618,1.466,3.985,3.985,0,0,1,.576,2.143,4.01,4.01,0,0,1-.576,2.174,3.889,3.889,0,0,1-1.628,1.436,5.493,5.493,0,0,1-2.447.516Zm-2.022,5.945V-56.184h2.75v14.215Zm7.765,0-4.691-6.147,2.528-.789,5.5,6.936Zm8.169-5.48-5.5-8.735H85.4l4.266,7h-1.82l4.266-7h3.134l-5.561,8.735Zm-.364,5.48v-6.956h2.77v6.956Z",
    transform: "translate(61.627 56.406)",
    fill: "#050d17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M7.71-41.969v-2.244h3.7a1.993,1.993,0,0,0,1.547-.607,2.054,2.054,0,0,0,.556-1.436,2.2,2.2,0,0,0-.243-1.031,1.8,1.8,0,0,0-.718-.738A2.257,2.257,0,0,0,11.41-48.3H7.71v-2.224h3.4a2.079,2.079,0,0,0,1.365-.425,1.554,1.554,0,0,0,.516-1.274,1.579,1.579,0,0,0-.516-1.294,2.079,2.079,0,0,0-1.365-.425H7.71v-2.244h3.721a4.975,4.975,0,0,1,2.376.516,3.566,3.566,0,0,1,1.446,1.355,3.591,3.591,0,0,1,.485,1.83A3.151,3.151,0,0,1,15-50.391a4.356,4.356,0,0,1-2.153,1.3l.121-.89A4.774,4.774,0,0,1,15.4-48.51a3.69,3.69,0,0,1,.859,2.457A3.891,3.891,0,0,1,15.707-44a4.006,4.006,0,0,1-1.618,1.476,5.5,5.5,0,0,1-2.578.556Zm-2.022,0V-56.184h2.73v14.215Zm12.355,0V-56.184h2.75v14.215Zm2.022,0v-2.447H27.3v2.447Zm32.939.2a7.442,7.442,0,0,1-2.891-.556,7.164,7.164,0,0,1-2.335-1.557,6.9,6.9,0,0,1-1.537-2.335,7.634,7.634,0,0,1-.536-2.871,7.634,7.634,0,0,1,.536-2.871,6.8,6.8,0,0,1,1.537-2.325A7.415,7.415,0,0,1,50.1-55.84a7.305,7.305,0,0,1,2.9-.566A7.525,7.525,0,0,1,56-55.85a7.422,7.422,0,0,1,2.285,1.527l-1.86,1.86a4.074,4.074,0,0,0-1.436-1.011A5,5,0,0,0,53-53.838a4.754,4.754,0,0,0-1.81.334,4.063,4.063,0,0,0-1.426.971,4.343,4.343,0,0,0-.93,1.517,5.555,5.555,0,0,0-.324,1.931,5.532,5.532,0,0,0,.324,1.941,4.362,4.362,0,0,0,.93,1.506,4.182,4.182,0,0,0,1.426.981,4.631,4.631,0,0,0,1.81.344,5.245,5.245,0,0,0,2.052-.364A3.939,3.939,0,0,0,56.5-45.71l1.86,1.86a7.051,7.051,0,0,1-2.305,1.537A7.913,7.913,0,0,1,53-41.767Zm15.468-.2L62.3-49.39l6.005-6.794h3.437L65.054-48.8l.02-1.274,6.9,8.108Zm-8.594,0V-56.184h2.75v14.215Z",
    transform: "translate(-5.688 56.406)",
    fill: "#050d17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(21.569 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_12",
    "data-name": "Subtraction 12",
    d: "M12.613,14.564H4.2L0,7.282,4.2,0h8.408l4.2,7.282-4.2,7.282h0ZM5.537,2.309,2.665,7.282l2.872,4.974H11.28l2.872-4.974L11.28,2.309Z",
    fill: "#204bf8",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(114.991 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_12-2",
    "data-name": "Subtraction 12",
    d: "M12.613,14.564H4.2L0,7.282,4.2,0h8.408l4.2,7.282-4.2,7.282h0ZM5.537,2.309,2.665,7.282l2.872,4.974H11.28l2.872-4.974L11.28,2.309Z",
    fill: "#204bf8",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(2363.69 1283.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(11.026 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_12-3",
    "data-name": "Subtraction 12",
    d: "M12.39,14.307H4.13L0,7.153,4.13,0h8.26l4.13,7.153-4.13,7.153ZM5.458,2.3l-2.8,4.854,2.8,4.854h5.605l2.8-4.854L11.063,2.3Z",
    transform: "translate(0 0)",
    fill: "#204bf8",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(0 9.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_12-4",
    "data-name": "Subtraction 12",
    d: "M10.033,11.585H3.344L0,5.792,3.344,0h6.689l3.344,5.792-3.343,5.792ZM4.626,2.22,2.564,5.792,4.626,9.365H8.751l2.062-3.572L8.751,2.22Z",
    transform: "translate(0 0)",
    fill: "#204bf8",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(12.623 16.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_12-5",
    "data-name": "Subtraction 12",
    d: "M7.463,8.618H2.488L0,4.309,2.488,0H7.464L9.952,4.309,7.464,8.618ZM3.792,2.258,2.607,4.309,3.792,6.36H6.16L7.344,4.309,6.16,2.258Z",
    transform: "translate(0 0)",
    fill: "#204bf8",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlockfactory);
export default __webpack_public_path__ + "static/media/logo_blockfactory.ff80bfd4306249647f967b5abb7b1e30.svg";
export { ForwardRef as ReactComponent };